'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _reactDom = require('react-dom');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Sizeable = function (_Component) {
  _inherits(Sizeable, _Component);

  function Sizeable(props) {
    _classCallCheck(this, Sizeable);

    var _this = _possibleConstructorReturn(this, (Sizeable.__proto__ || Object.getPrototypeOf(Sizeable)).call(this, props));

    _this.state = { size: null };

    _this.setSize = _this.setSize.bind(_this);
    return _this;
  }

  _createClass(Sizeable, [{
    key: 'representSize',
    value: function representSize(size) {
      var _props = this.props;
      var width = _props.width;
      var height = _props.height;

      if (size == null) return size;

      var sizeProps = {};
      if (width) sizeProps.width = size[0];
      if (height) sizeProps.height = size[1];
      if (width && height) sizeProps.size = size;
      return sizeProps;
    }
  }, {
    key: 'setSize',
    value: function setSize() {
      var _props2 = this.props;
      var width = _props2.width;
      var height = _props2.height;
      var size = this.state.size;
      var node = (0, _reactDom.findDOMNode)(this);

      var newSize = [typeof width === 'function' ? width(node) : typeof width === 'number' ? width : width ? node.parentNode.offsetWidth : null, typeof height === 'function' ? height(node) : typeof height === 'number' ? height : height ? node.parentNode.offsetHeight : null];

      if (size == null) {
        this.setState({ size: newSize });
      } else if (this.shouldResize(this.representSize(size), this.representSize(newSize))) {
        // Redundancy to work around Edge greedily evaluating operands
        this.setState({ size: newSize });
      }
    }
  }, {
    key: 'shouldResize',
    value: function shouldResize(previous, current) {
      return this.props.width && current.width !== previous.width || this.props.height && current.height !== previous.height;
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.setSize();
      window.addEventListener('resize', this.setSize);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.setSize);
    }
  }, {
    key: 'extraProps',
    value: function extraProps() {
      var props = _extends({}, this.props);
      delete props.children;
      delete props.component;
      delete props.width;
      delete props.height;
      return props;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var size = this.state.size;
      var _props3 = this.props;
      var children = _props3.children;
      var component = _props3.component;


      return component != null ? (0, _react.createElement)(component, this.extraProps(), size && (typeof children === 'function' ? children(this.representSize(size)) : _react.Children.map(function (child) {
        return (0, _react.cloneElement)(child, _this2.representSize(size));
      }))) : size == null ? (0, _react.createElement)('span') : typeof children === 'function' ? children(this.representSize(size)) : (0, _react.cloneElement)(_react.Children.only(children), this.representSize(size));
    }
  }]);

  return Sizeable;
}(_react.Component);

Sizeable.propTypes = {
  width: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.func]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.number, _propTypes2.default.func]),
  component: _propTypes2.default.any
};
Sizeable.defaultProps = {
  width: true,
  height: false
};
exports.default = Sizeable;


//////////////////
// WEBPACK FOOTER
// ./~/react-sizeable/dist/index.js
// module id = 35
// module chunks = 0